import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { CircularProgress, Tooltip, Typography } from '@mui/material'
import { ReactComponent as Arrow } from 'assets/icons/chevronBlue.svg'
import classNames from 'classnames'
import { AddAddressBtn } from 'feature/addresses/components/AddAddressBtn'
import { AddressesHeader } from 'feature/addresses/components/AddressesHeader'
import {
  SavedAddress,
  SavedAddressList,
} from 'feature/addresses/redux/MyAddresses.api'
import { ScreenEnum, useScreen } from 'feature/screenMode'
import { FC, useState } from 'react'
import { Box, Button, Modal } from 'ui'

import styles from './AddressesList.module.scss'

interface IAddressesList {
  addressesData: SavedAddressList
  setViewModeToForm: (arg0: null | SavedAddress) => void
  isLoadingId: number | null
  isLoadingAdding: boolean
}

// список "МОИ АДРЕСА" (для страницы "/myaddresses")
export const AddressesList: FC<IAddressesList> = ({
  addressesData,
  setViewModeToForm,
  isLoadingId,
  isLoadingAdding,
}) => {
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const screen = useScreen()

  return (
    <main className={styles.settingPage}>
      <AddressesHeader showBack={false} />
      <div className={styles.addressMenu}>
        {addressesData &&
          !isLoadingAdding &&
          addressesData.list.map((item: SavedAddress) => {
            if (item.isMain) {
              return (
                <Button
                  key={item.id}
                  className={classNames(
                    styles.addressItem,
                    styles.addressItemNotActive,
                  )}
                  data-testid={`address-main-${item.id}`}
                >
                  <div className={styles.address}>
                    <span>{item.address}</span>
                  </div>

                  {screen !== ScreenEnum.desktop ? (
                    <button
                      onClick={handleOpen}
                      data-testid={`address-main-info-${item.id}`}
                    >
                      <ErrorOutlineIcon />
                    </button>
                  ) : (
                    <Tooltip
                      title={`Для редактирования основного адреса 
                        необходимо перейти в настройки профиля`}
                    >
                      <ErrorOutlineIcon />
                    </Tooltip>
                  )}
                  <Modal open={open} onClose={handleClose}>
                    <>
                      <Box className={styles.modal}>
                        <Typography>
                          Для редактирования основного адреса необходимо перейти
                          в настройки профиля
                        </Typography>
                      </Box>
                    </>
                  </Modal>
                </Button>
              )
            } else {
              return (
                <Button
                  key={item.id}
                  className={styles.addressItem}
                  onClick={() => {
                    setViewModeToForm(item)
                  }}
                  data-testid={`address-item-${item.id}`}
                >
                  <div className={styles.address}>
                    <span>{item.address}</span>
                  </div>
                  {isLoadingId === item.id ? (
                    <CircularProgress size={25} />
                  ) : (
                    <Arrow />
                  )}
                </Button>
              )
            }
          })}
      </div>
      <AddAddressBtn onClick={setViewModeToForm} />
    </main>
  )
}
